import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';

const PrivacyNoticeStep = ({ privacyAgreement, setPrivacyAgreement, themeColors, startTimer }) => {
  // Function to handle the agreement button click
  const handleAgreeClick = () => {
    // Set the privacy agreement state to true
    setPrivacyAgreement(true);
    
    // Call startTimer if it exists as a prop
    if (startTimer && typeof startTimer === 'function') {
      startTimer();
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', fontSize: { xs: '1rem', sm: '1.25rem' } }}>
        Data Privacy Notice
      </Typography>
      
      <Paper 
        elevation={0} 
        sx={{ 
          p: { xs: 2, sm: 3 }, 
          mb: 3, 
          backgroundColor: '#f9f9f9', 
          border: `1px solid ${themeColors.borderColor}`,
          borderRadius: 1,
          maxHeight: { xs: '200px', sm: '250px', md: '300px' },
          overflow: 'auto'
        }}
      >
        <Typography variant="body1" sx={{ mb: 2, textAlign: 'justify', fontSize: { xs: '0.875rem', sm: '1rem' } }}>
          In accordance with its mandate to protect and promote the right to quality basic education, 
          the Department of Education XI collects various data, including personal information, 
          using different systems and is committed to ensure the free flow of information as required 
          by the Freedom of Information Act (Executive Order No. 2, s. 2016) while protecting the 
          confidentiality and privacy of this data as mandated by the Data Privacy Act of 2012 
          (Republic Act No. 10173).
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, textAlign: 'justify', fontSize: { xs: '0.875rem', sm: '1rem' } }}>
          To read more, visit <a href="https://www.deped.gov.ph/about-deped/data-privacy-notice/" 
          target="_blank" rel="noopener noreferrer" style={{ color: themeColors.primary, wordBreak: 'break-all' }}>
            https://www.deped.gov.ph/about-deped/data-privacy-notice/
          </a>
        </Typography>
      </Paper>
      
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <Button
          variant={privacyAgreement ? "contained" : "outlined"}
          onClick={handleAgreeClick}
          sx={{ 
            backgroundColor: privacyAgreement ? themeColors.primary : 'transparent',
            color: privacyAgreement ? 'white' : themeColors.primary,
            mr: 2,
            borderColor: themeColors.primary,
            '&:hover': {
              backgroundColor: privacyAgreement ? themeColors.primaryLight : 'rgba(128, 0, 0, 0.04)',
              borderColor: themeColors.primary
            }
          }}
        >
          I agree
        </Button>
      </Box>
    </Box>
  );
};

export default PrivacyNoticeStep;